<template>
  <div
    class="login-page min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-neutral-50"
  >
    <div
      class="max-w-md w-full space-y-8 bg-white p-8 rounded-2xl shadow-sm border border-neutral-100"
    >
      <div class="text-center">
        <h2 class="mt-6 text-3xl font-extrabold text-neutral-900">欢迎回来</h2>
        <p class="mt-2 text-sm text-neutral-600">
          登录您的账户以管理收藏和提交工具
        </p>
      </div>

      <!-- 错误/成功提示 -->
      <div
        v-if="message.content"
        :class="[
          'p-4 rounded-lg text-sm mb-4',
          message.type === 'error'
            ? 'bg-red-50 text-red-600'
            : 'bg-green-50 text-green-600',
        ]"
      >
        <i
          :class="[
            'fa mr-2',
            message.type === 'error'
              ? 'fa-exclamation-circle'
              : 'fa-check-circle',
          ]"
        ></i>
        {{ message.content }}
      </div>

      <form class="mt-8 space-y-6" @submit.prevent="handleLogin">
        <div class="rounded-md shadow-sm -space-y-px">
          <div class="mb-4">
            <label
              for="username"
              class="block text-sm font-medium text-neutral-700 mb-1"
              >用户名</label
            >
            <input
              id="username"
              name="username"
              type="text"
              required
              v-model="form.username"
              class="appearance-none relative block w-full px-3 py-3 border border-neutral-300 placeholder-neutral-500 text-neutral-900 rounded-lg focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
              placeholder="请输入用户名"
            />
          </div>
          <div class="mb-4">
            <label
              for="password"
              class="block text-sm font-medium text-neutral-700 mb-1"
              >密码</label
            >
            <input
              id="password"
              name="password"
              type="password"
              required
              v-model="form.password"
              class="appearance-none relative block w-full px-3 py-3 border border-neutral-300 placeholder-neutral-500 text-neutral-900 rounded-lg focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
              placeholder="请输入密码"
            />
          </div>
        </div>

        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <input
              id="remember-me"
              name="remember-me"
              type="checkbox"
              v-model="form.rememberMe"
              class="h-4 w-4 text-primary focus:ring-primary border-neutral-300 rounded cursor-pointer"
            />
            <label
              for="remember-me"
              class="ml-2 block text-sm text-neutral-900 cursor-pointer"
            >
              记住我
            </label>
          </div>

          <div class="text-sm">
            <a
              href="#"
              class="font-medium text-primary hover:text-primary-dark"
            >
              忘记密码?
            </a>
          </div>
        </div>

        <div>
          <button
            type="submit"
            :disabled="isLoading"
            class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors disabled:opacity-70"
          >
            <span class="absolute left-0 inset-y-0 flex items-center pl-3">
              <i
                class="fa fa-sign-in group-hover:text-primary-light"
                aria-hidden="true"
              ></i>
            </span>
            {{ isLoading ? "登录中..." : "登录" }}
          </button>
        </div>
      </form>

      <div class="text-center mt-4">
        <p class="text-sm text-neutral-600">
          还没有账户?
          <router-link
            to="/register"
            class="font-medium text-primary hover:text-primary-dark"
          >
            立即注册
          </router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      form: {
        username: "",
        password: "",
        rememberMe: false,
      },
      message: {
        type: "",
        content: "",
      },
      isLoading: false,
    };
  },
  methods: {
    async handleLogin() {
      this.isLoading = true;
      this.message = { type: "", content: "" };

      this.isLoading = false;

      // 简单验证
      if (this.form.username.length > 0 && this.form.password.length > 0) {
        // 登录成功
        // this.message = { type: 'success', content: '登录成功！正在跳转...' };

        // // 存储token (模拟)
        // localStorage.setItem('token', 'mock-token-' + Date.now());
        // localStorage.setItem('user', JSON.stringify({ username: this.form.username }));

        // // 跳转首页

        var data = await this.$aesEncrypt({
          loginId: this.form.username,
          password: this.form.password,
        });
        this.$axios({
          url: "user/login",
          method: "POST",
          data: {
            data: data,
          },
        }).then((res) => {
          if (res.code == 200) {
            var user = res.data;
            this.message = {
              type: "success",
              content: "登录成功！正在跳转...",
            };
            console.log(JSON.stringify(user));
            localStorage.setItem("token", user.token);
            this.$store.commit("setUserInfo", user);
            setTimeout(() => {
              this.$router.push("/");
            }, 1000);
          } else {
            this.message = { type: "error", content: res.msg };
          }
        });
      } else {
        // 登录失败
        this.message = { type: "error", content: "用户名或密码错误" };
      }
    },
  },
};
</script>
